import { gql } from '@apollo/client';

export const CONFIRM_INVOICE_ORDER = gql`
  mutation ConfirmInvoiceOrder($input: ConfirmInvoiceOrderInput!) {
    confirmInvoiceOrder(input: $input) {
      __typename
      ... on InvoiceOrderSuccessPayload {
        responseStatus
      }
      ... on InvoiceOrderNotFoundPayload {
        reason
      }
      ... on OrderExpiredError {
        message
      }
      ... on OrderNotFoundError {
        message
      }
      ... on OrderInvalidError {
        message
      }
      ... on PromotionInvalidError {
        message
      }
    }
  }
`;

export const CREATE_STRIPE_PAYMENT_INTENT = gql`
  mutation CreateStripePaymentIntent($input: CreateStripePaymentIntentInput!) {
    createStripePaymentIntent(input: $input) {
      __typename
      ... on StripePaymentIntentPayload {
        clientSecret
        qrCodeUrl
        paymentLink
      }
      ... on PaymentMethodError {
        message
      }
      ... on OrderNotFoundError {
        message
      }
      ... on OrderExpiredError {
        message
      }
      ... on OrderInvalidError {
        message
      }
      ... on PromotionInvalidError {
        message
      }
    }
  }
`;

export const CREATE_STRIPE_INVOICE_PAYMENT_INTENT = gql`
  mutation CreateStripePaymentIntentForInvoice(
    $seekBillingAccountId: String!
    $seekAdvertiserId: String
    $paymentMethod: StripePaymentMethod!
    $totalForPaymentIntent: SafeInt!
    $creditCardBrand: CreditCardBrandInput
    $invoices: [InvoiceInput!]!
    $email: String!
    $prn: String!
    $expiryDays: Int
    $saveCard: Boolean
    $idempotencyKey: String
  ) {
    createStripePaymentIntentForInvoice(
      input: {
        seekBillingAccountId: $seekBillingAccountId
        seekAdvertiserId: $seekAdvertiserId
        paymentMethod: $paymentMethod
        totalForPaymentIntent: $totalForPaymentIntent
        creditCardBrand: $creditCardBrand
        invoices: $invoices
        email: $email
        prn: $prn
        expiryDays: $expiryDays
        saveCard: $saveCard
        idempotencyKey: $idempotencyKey
      }
    ) {
      __typename
      ... on StripePaymentIntentPayload {
        clientSecret
        id
        qrCodeUrl
        paymentLink
        reference
      }
      ... on PaymentMethodError {
        message
      }
      ... on OrderNotFoundError {
        message
      }
      ... on OrderExpiredError {
        message
      }
      ... on OrderInvalidError {
        message
      }
      ... on PromotionInvalidError {
        message
      }
      ... on InvoiceError {
        message
      }
    }
  }
`;

export const PAY_BY_STRIPE_SAVED_CREDIT_CARD = gql`
  mutation PayByStripeSavedCreditCard(
    $creditCardBrand: CreditCardBrandInput!
    $orderId: ID!
    $paymentMethodId: String!
  ) {
    payByStripeSavedCreditCard(
      input: {
        creditCardBrand: $creditCardBrand
        orderId: $orderId
        paymentMethodId: $paymentMethodId
      }
    ) {
      ... on SavedCreditCardPaymentSuccessPayload {
        paymentIntentId
        clientSecret
      }
      ... on SavedCreditCardPaymentError {
        message
        errorCode
        declineCode
        param
        paymentIntentId
        paymentIntentStatus
      }
      ... on OrderNotFoundError {
        message
      }
      ... on OrderExpiredError {
        message
      }
      ... on OrderInvalidError {
        message
      }
      ... on PromotionInvalidError {
        message
      }
    }
  }
`;

export const PAY_INVOICE_BY_STRIPE_SAVED_CREDIT_CARD = gql`
  mutation PayByStripeSavedCreditCardForInvoice(
    $creditCardBrand: CreditCardBrandInput!
    $seekBillingAccountId: String!
    $seekAdvertiserId: String!
    $prn: String!
    $totalForPaymentIntent: SafeInt!
    $invoices: [InvoiceInput!]!
    $email: String!
    $paymentMethodId: String!
    $idempotencyKey: String
  ) {
    payByStripeSavedCreditCardForInvoice(
      input: {
        creditCardBrand: $creditCardBrand
        seekBillingAccountId: $seekBillingAccountId
        seekAdvertiserId: $seekAdvertiserId
        prn: $prn
        totalForPaymentIntent: $totalForPaymentIntent
        invoices: $invoices
        email: $email
        paymentMethodId: $paymentMethodId
        idempotencyKey: $idempotencyKey
      }
    ) {
      ... on SavedCreditCardPaymentSuccessPayload {
        paymentIntentId
        clientSecret
      }
      ... on SavedCreditCardPaymentError {
        message
        errorCode
        declineCode
        param
        paymentIntentId
        paymentIntentStatus
      }
    }
  }
`;

export const DELETE_STRIPE_SAVED_CREDIT_CARD = gql`
  mutation DeleteStripeSavedCreditCard(
    $advertiserNation: String!
    $paymentMethodId: String!
  ) {
    deleteStripeSavedCreditCard(
      input: {
        advertiserNation: $advertiserNation
        paymentMethodId: $paymentMethodId
      }
    ) {
      successful
    }
  }
`;

export const CREATE_2C2P_PAYMENT_INTENT = gql`
  mutation Create2C2PPaymentIntent($input: Create2C2PPaymentIntentInput!) {
    create2C2PPaymentIntent(input: $input) {
      ... on PaymentIntent2C2PPayload {
        __typename
        paymentLink
        paymentToken
        expiryTimer
      }
      ... on PaymentIntentChargeError {
        __typename
        message
        code
      }
      ... on PaymentMethodError {
        __typename
        message
      }
      ... on OrderNotFoundError {
        __typename
        message
      }
      ... on OrderExpiredError {
        __typename
        message
      }
      ... on OrderInvalidError {
        __typename
        message
      }
      ... on PromotionInvalidError {
        __typename
        message
      }
    }
  }
`;

export const CREATE_2C2P_INVOICE_PAYMENT_INTENT = gql`
  mutation Create2C2PPaymentIntentForInvoice(
    $input: Create2C2PPaymentIntentForInvoiceInput!
  ) {
    create2C2PPaymentIntentForInvoices(input: $input) {
      ... on PaymentIntent2C2PPayload {
        paymentLink
        paymentToken
        expiryTimer
      }
      ... on PaymentMethodError {
        message
      }
      ... on PaymentIntentChargeError {
        message
        code
      }
      ... on OrderNotFoundError {
        message
      }
      ... on OrderExpiredError {
        message
      }
      ... on OrderInvalidError {
        message
      }
      ... on PromotionInvalidError {
        message
      }
      ... on InvoiceError {
        message
      }
    }
  }
`;

export const CREATE_SEEK_PAYMENT_INTENT = gql`
  mutation CreatePaymentIntent(
    $seekPaymentIntentId: String
    $paymentMethod: String
    $site: Site
    $country: Country
  ) {
    createPaymentIntent(
      seekPaymentIntentId: $seekPaymentIntentId
      paymentMethod: $paymentMethod
      site: $site
      country: $country
    ) {
      clientSecret
      id
      qrCodeUrl
      paymentLink
      reference
    }
  }
`;

export const CREATE_PAYAAS_STRIPE_PAYMENT_INTENT = gql`
  mutation CreatePayaasStripePaymentIntent(
    $seekPaymentIntentId: String
    $paymentMethod: String
    $site: Site
    $country: Country
  ) {
    createStripePaymentIntent(
      seekPaymentIntentId: $seekPaymentIntentId
      paymentMethod: $paymentMethod
      site: $site
      country: $country
    ) {
      clientSecret
      id
      qrCodeUrl
      paymentLink
      reference
    }
  }
`;

export const CREATE_PAYAAS_2C2P_PAYMENT_INTENT = gql`
  mutation CreatePayaas2c2pPaymentIntent(
    $create2C2PPaymentIntentSeekPaymentIntentId2: String
    $create2C2PPaymentIntentPaymentMethod2: String
    $create2C2PPaymentIntentSite2: Site
    $create2C2PPaymentIntentCountry2: Country
    $paymentMethodType: String
    $channelCode: String
    $email: String
    $frontendReturnUrl: String
    $accountNo: String
  ) {
    create2c2pPaymentIntent(
      seekPaymentIntentId: $create2C2PPaymentIntentSeekPaymentIntentId2
      paymentMethod: $create2C2PPaymentIntentPaymentMethod2
      site: $create2C2PPaymentIntentSite2
      country: $create2C2PPaymentIntentCountry2
      paymentMethodType: $paymentMethodType
      channelCode: $channelCode
      email: $email
      frontendReturnUrl: $frontendReturnUrl
      accountNo: $accountNo
    ) {
      paymentLink
      paymentToken
      expiryTimer
    }
  }
`;
